import styled from "styled-components"

export const FileUploaderContainer = styled.div`
	margin-right: 22px;
	label {
		cursor: pointer;
	}
`
